import { NotificationData } from "./notifications.interface";
import { RecordingConfig } from '@core/models/recording-config.model';
// services
import { NotificationsService } from '@core/services/notifications/notifications.service';

export interface ResultVideoSpecs {
  cameraWidth: number;
  cameraHeight: number;
  frameRate: number;
  screenWidth: number;
  screenHeight: number;
};

/**
 * this class includes 3 available streams for record 3 sources of media
 */
export class RecordStreams {
  private _audio: MediaStream | null;
  private _cam: MediaStream | null;
  private _screen: MediaStream | null;
  
  constructor(audio: MediaStream | null, cam: MediaStream | null, screen: MediaStream | null) {
      this._audio = audio;
      this._cam = cam;
      this._screen = screen;
  }

  get audio(): MediaStream | null {
      return this._audio;
  }
  get cam(): MediaStream | null {
      return this._cam;
  }
  get screen(): MediaStream | null {
      return this._screen;
  }
}
/**
 * this class manage the streams we get and get data, combine data and 
 * manage streams according given config 
 */
export class Record {
    public id: string;
    public config: RecordingConfig;
    public data: NotificationData;
    public created: Date;
    private _streams: RecordStreams;
    public chunks;
    // DEFAULT VIDEO CONFIG in case of we need it
    private defaultVideoSpecs: ResultVideoSpecs = {
      cameraWidth: 1280,
      cameraHeight: 720,
      frameRate: 30,
      screenWidth: 1920,
      screenHeight: 1080
    };

    constructor(config: RecordingConfig, data: NotificationData,) {
        this.id = Math.random().toString(36).replace('0.', '');
        this.config = config;
        this.data = data;
        this.created = new Date();

        
    }

    /**
     * Starts the streams needed according the options in the config.
     */
    async prepareRecord() : Promise<void> {
      let audioStream;
      let videoStream;
      let screenStream;
      try {
        audioStream = this.config.selectedMicId
          ?   await navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: this.config.selectedMicId } } })
          : null;
      } catch (error) {
        console.error('Failed to start recording due to audio devices access! ', error);
        return Promise.reject(error);
      }
      try {
        videoStream = this.config.selectedCamId
        ? await navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: this.config.selectedCamId },
            width: this.defaultVideoSpecs.cameraWidth,
            height: this.defaultVideoSpecs.cameraHeight,
         } })
        : null;
      } catch (error) {
        console.error('Failed to start recording due to video devices access! ', error);
        return Promise.reject(error);
      } 
      try {
        screenStream = this.config.selectedScreenRecording
        ? await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false })
        : null;
      } catch (error) {
        console.error('Failed to start recording due to screen devices access! ', error);
        return Promise.reject(error); 
      }
      // NOTE: on the Promise reject we can send message error to the notification on the startFail effect
       
      try {
          this._streams = new RecordStreams(audioStream,videoStream,screenStream);
        console.log('Dispatch start recording',  this.streams);
        return Promise.resolve();
      } catch (error) {
        console.error('Failed to start recording due to ! ', error);
        return Promise.reject(error);
      }
    }

    /**
     * Combine all streams available
     * 
     * @returns the MediaStream object result of combined all the streams available
     */
    getCombinedStreams(): MediaStream {
      const combinedStream = new MediaStream();
      if(this.streams.audio)
          combinedStream.addTrack(this.streams.audio.getAudioTracks()[0]);
      if(this.streams.cam && !this.streams.screen) // only add stream of the cam when there is no screen (only cam) 
          combinedStream.addTrack(this.streams.cam.getVideoTracks()[0]);
      if(this.streams.screen)    
          combinedStream.addTrack(this.streams.screen.getVideoTracks()[0]);
      return combinedStream;
    }

    /**
     * In order to stop the recording and release the user’s devices, 
     * we need to call the stop() method on each track of the streams
     */
    stopStreams() : void {
      if(this.streams.audio)
        this.streams.audio.getTracks().forEach(track => track.stop());
      if(this.streams.cam)    
        this.streams.cam.getTracks().forEach(track => track.stop());
      if(this.streams.screen)    
        this.streams.screen.getTracks().forEach(track => track.stop());
    }


    /**
     * get the 3 streams
     */
    public get streams() : RecordStreams {
      return this._streams;
    }
    

   
}
  